import React from 'react';
import { HiMiniWrenchScrewdriver } from 'react-icons/hi2';
import { MdAnchor } from 'react-icons/md';

import { ButtonSmall } from '@/components/Button';
import { MARINA_RIGHTS } from '@/permissions/route-rights';
import { usePermissions } from '@/permissions/usePermissions';

import styles from './ChosenYachtControls.module.scss';

interface ChosenYachtControlsProps {
  onMarinaClick?: () => void;
  onServiceClick?: () => void;
  className?: string;
}

export const ChosenYachtControls: React.FC<ChosenYachtControlsProps> = ({
  onMarinaClick,
  onServiceClick,
  className,
}) => {
  const { canAny } = usePermissions();

  return (
    <div className={`${styles.chosenYachtButtons} ${className || ''}`}>
      {/* My marinas — guests and vendors have nothing to open there. */}
      {canAny([...MARINA_RIGHTS]) && (
        <ButtonSmall type="button" onClick={onMarinaClick}>
          <span className={styles.label}>Marina</span> <MdAnchor />
        </ButtonSmall>
      )}
      <ButtonSmall type="button" onClick={onServiceClick}>
        <HiMiniWrenchScrewdriver /> <span className={styles.label}>Service</span>
      </ButtonSmall>
    </div>
  );
};
